import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { List } from 'immutable';

import Checkmark from 'components/svgs/checkmark';

import AppLink from 'containers/common/app-link';
import Brand from 'models/brand';
import User from 'models/user';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  bookings: PropTypes.instanceOf(List).isRequired,
  user: PropTypes.instanceOf(User).isRequired,
};

const defaultPropTypes = {
};

class NextSteps extends Component {
  renderPassLink() {
    const { bookings } = this.props;
    const booking = bookings.first();

    if (booking.type === 'monthly_booking') {
      return null;
    }

    if (bookings.size === 1) {
      return (
        <div className="fill-green next-steps-item">
          <Checkmark />
          Open your pass & follow instructions to park.&nbsp;
          <Link
            to={{
              pathname: `/ticket/${booking.id}/`,
              search: `?u=${booking.authorizationCode}`,
            }}
          >
            View my pass now.
          </Link>
        </div>
      );
    }

    return (
      <div className="fill-green next-steps-item">
        <Checkmark />
          Open your passes & follow instructions to park.&nbsp;
        <Link to={{ pathname: '/account/' }}>
            View my passes now.
        </Link>
      </div>
    );
  }

  renderDownloadLink() {
    const { brand, bookings } = this.props;
    if (!brand.showAppDownloadInformation) { return null; }

    const booking = bookings.first();
    const downloadText = booking.type === 'monthly_booking' ? 'Get parking on the go!' : 'Access your pass on the go!';

    return (
      <div>
        <div className="fill-green visible-lte-sm next-steps-item"><Checkmark />{downloadText} <AppLink linkProps={{ c: 'thank_you_page' }}>Download our app.</AppLink></div>
        <div className="fill-green hidden-lte-sm next-steps-item"><Checkmark />{downloadText} Download our app on <AppLink appStore="apple" linkProps={{ c: 'thank_you_page' }}>iPhone</AppLink> or <AppLink appStore="android" linkProps={{ c: 'thank_you_page' }}>Android</AppLink>.</div>
      </div>
    );
  }

  renderRefferalLink() {
    if (!this.props.user.jwt || !this.props.brand.showReferralProgram) { return null; }

    return (
      <div className="fill-green next-steps-item hidden-xs"><Checkmark />Pass on the savings. <a href="#" className="squatchpop">Give a friend a $5 break and get $10 for every two friends who give us a try!</a></div>
    );
  }

  render() {
    return (
      <div className="next-steps">
        {this.renderPassLink()}
        {this.renderDownloadLink()}
        {!this.props.brand.isBestParking && this.renderRefferalLink()}
      </div>
    );
  }
}

NextSteps.propTypes = propTypes;
NextSteps.defaultPropTypes = defaultPropTypes;

export default NextSteps;
